import { ADD_INTERNALTRANSACTION, ADD_INTERNALTRANSACTION_FAILURE, ADD_INTERNALTRANSACTION_SUCCESS, ADD_TRANSACTION, ADD_TRANSACTIONTOCSV, ADD_TRANSACTIONTOCSV_SUCCESS, ADD_TRANSACTIONTOCSV_FAILURE, ADD_TRANSACTION_FAILURE, ADD_TRANSACTION_SUCCESS, INTERNAL_TRANSACTION, INTERNAL_TRANSACTION_FAILURE, INTERNAL_TRANSACTION_SUCCESS, SINGLE_TRANSACTION, SINGLE_TRANSACTION_FAILURE, SINGLE_TRANSACTION_SUCCESS, TRANSACTION, TRANSACTION_FAILURE, TRANSACTION_SUCCESS, UPDATEINTERNALTRANSACTION, UPDATEINTERNALTRANSACTION_SUCCESS, UPDATETRANSACTION, UPDATETRANSACTION_FAILURE, UPDATETRANSACTION_SUCCESS } from "./actionTypes"

let initialState = {
    transactions: [],
    internalTransactions: [],
    transactionDetails: {},
    addInternalTransaction: "",
    addTransaction: "",
    updateTransaction: "",
    updateInternalTransaction: "",
    loading: false,
    success: false,
    error: ''
}

export const transactionReducers = (state = initialState, action) => {
    switch (action.type) {
        case TRANSACTION: return {
            ...state,
            transactions: [],
            loading: true,
            success: false,
            error: ''
        }
        case TRANSACTION_SUCCESS: return {
            ...state,
            transactions: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case TRANSACTION_FAILURE: return {
            ...state,
            transactions: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case INTERNAL_TRANSACTION: return {
            ...state,
            internalTransactions: [],
            loading: true,
            success: false,
            error: ''
        }
        case INTERNAL_TRANSACTION_SUCCESS: return {
            ...state,
            internalTransactions: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case INTERNAL_TRANSACTION_FAILURE: return {
            ...state,
            internalTransactions: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case SINGLE_TRANSACTION: return {
            ...state,
            transactionDetails: {},
            loading: true,
            success: false,
            error: ''
        }
        case SINGLE_TRANSACTION_SUCCESS: return {
            ...state,
            transactionDetails: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case SINGLE_TRANSACTION_FAILURE: return {
            ...state,
            transactionDetails: {},
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_TRANSACTION: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_TRANSACTION_SUCCESS: return {
            ...state,
            addTransaction: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case ADD_TRANSACTION_FAILURE: return {
            ...state,
            addTransaction: '',
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_TRANSACTIONTOCSV: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_TRANSACTIONTOCSV_SUCCESS: return {
            ...state,
            addTransaction: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case ADD_TRANSACTIONTOCSV_FAILURE: return {
            ...state,
            addTransaction: '',
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_INTERNALTRANSACTION: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_INTERNALTRANSACTION_SUCCESS: return {
            ...state,
            addInternalTransaction: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case ADD_INTERNALTRANSACTION_FAILURE: return {
            ...state,
            addInternalTransaction: '',
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATETRANSACTION: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATETRANSACTION_SUCCESS: return {
            ...state,
            updateTransaction: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATETRANSACTION_FAILURE: return {
            ...state,
            updateTransaction: '',
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATEINTERNALTRANSACTION: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATEINTERNALTRANSACTION_SUCCESS: return {
            ...state,
            updateInternalTransaction: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATETRANSACTION_FAILURE: return {
            ...state,
            updateInternalTransaction: '',
            loading: false,
            success: false,
            error: action.payload
        }
        default: return state
    }
}